module.exports = __webpack_public_path__ + "img/scence4.73578efd.jpg";